module.exports = __webpack_public_path__ + "img/appleStoreBg.17a12ba1.png";